import React, {
  useState,
  useRef,
  useEffect,
  useLayoutEffect,
  useContext,
} from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
} from 'react-router-dom';
import Ping from 'ping.js';
import styled from 'styled-components';
import GlobalStyles from './components/globals/GlobalStyles';
import ExhibitorContext from './context/exhibitorContext';
import Register from './components/registrationForm/Register';
import Register2 from './components/registrationForm/Register2';
import SliderPage from './pages/SliderPage';
import RegistrationForm from './components/registrationForm/RegistrationForm';
import { Provider as UserProvider } from './context/UserContext';
import { Provider as AttendantProvider } from './context/AttendantContext';
import { Provider as ClientProvider } from './context/ClientContext';
import { Context as SocketContext } from './context/SocketContext';
import ResetPassword from './components/registrationForm/ResetPassword';
import SiteData from './config';
import AttendantDashboard from './components/AttendantConsole/AttendantDashboard';
import AttendantTileEditor from './components/AttendantConsole/AttendantTileEditor';
import NavbarAttendant from './components/globals/NavbarAttendant';
import ForgotPassword from './components/registrationForm/ForgotPassword';
import ClientLogin from './components/ClientConsole/ClientLogin';
import ClientDashboard from './components/ClientConsole/ClientDashboard';
import NavbarClient from './components/ClientConsole/NavbarClient';
import AuditoriumPage from './pages/AuditoriumPage';
import AuditoriumPage2 from './pages/AuditoriumPage2';
import { NotificationMessage } from './components/globals/NotificationMessage';
import {
  Socket,
  createSocket,
  heartbeat_msg,
} from './api/expoHallSocket';
import EndofEventPage from './pages/EndofEventPage';
import LoadingPage from './pages/LoadingPage';
import Axios from 'axios';
import Countdown from 'react-countdown';

let ping_interval = null;
let missedCounter = 0;
const App = ({ className }) => {
  const [exhibitorData, setExhibitorData] = useState([]);
  const History = useHistory();
  const [missedHeartbeats, setMissedHeartbeats] = useState(0);
  const [attendantNavbarBackLink, setAttendantNavbarBackLink] = useState(
    '/auditorium'
  );
  const [pingData, setpingData] = useState();
  const [missedPings, setmissedPings] = useState(0);

  const ping = new Ping({ timeout: 230 });

  useLayoutEffect(() => {
    document.title = SiteData.titleIndex;
  }, []);

  // useEffect(() => {
  //   handlePing();
  // }, []);

  // const handlePing = () => {
  //   ping_interval = setInterval(() => {
  //     ping.ping(
  //       'https://status.digitalvirtualspaces.com',
  //       (err, data) => {
  //         missedCounter++;
  //         if (err) {
  //           if (missedCounter >= 5) {
  //             clearInterval(ping_interval);
  //             handleDoomsday();
  //           }
  //         } else {
  //           missedCounter = 0;
  //           console.log('healthy');
  //         }
  //       }
  //     );
  //   }, 5500);
  // };

  // const handleDoomsday = async () => {
  //   const { data } = await Axios.get(
  //     'https://nabj.mbvsbackend.com/api/dooms_day/1/'
  //   );
  //   if (data) {
  //     switch (data.status) {
  //       case 'good':
  //         missedCounter = 0;
  //         handlePing();
  //         break;

  //       case 'bad':
  //         const notification = {
  //           title: 'Attention',
  //           message: `We are experiencing some technical difficulties, you will be moved to an alternative page. If you are not moved copy and paste the following link: redirect.digitalvirtualspaces.com`,
  //           type: 'danger',
  //           insert: 'top',
  //           container: 'top-center',
  //           duration: 60000,
  //         };
  //         NotificationMessage(notification);
  //         setTimeout(() => {
  //           window.open(
  //             'https://redirect.digitalvirtualspaces.com'
  //           );
  //           window.close();
  //         }, 60000);
  //         break;

  //       default:
  //     }
  //   }
  // };

  return (
    <div className={className}>
      <GlobalStyles />
      <NotificationMessage />
      <UserProvider>
        <ExhibitorContext.Provider value={exhibitorData}>
          <AttendantProvider>
            <ClientProvider>
              <Router>
                <Switch>
                  <Route exact path="/">
                    {/* <Navbar /> */}
                    <SliderPage />
                  </Route>
                  {SiteData.auditorium && SiteData.isMultipleAuditorium ? (
                    <Route exact path="/auditorium/:id">
                      <AuditoriumPage />
                    </Route>
                  ) : (
                    <Route exact path="/auditorium">
                      <AuditoriumPage />
                    </Route>
                  )}
                  {SiteData.auditorium && (
                    <Route exact path="/closing">
                      <EndofEventPage />
                    </Route>
                  )}
                  <Route path="/login">
                    {/* <LoginForm /> */}
                    <RegistrationForm />
                  </Route>
                  <Route path="/register">
                    {' '}
                    <Register2 />{' '}
                  </Route>
                  <Route path="/forgotpassword">
                    {' '}
                    <ForgotPassword />{' '}
                  </Route>
                  <Route path="/reset/:uuid/:token">
                    {' '}
                    <ResetPassword />{' '}
                  </Route>
                  <Route exact path="/dashboard">
                    <NavbarAttendant
                      attendantNavbarBackLink={attendantNavbarBackLink}
                    />
                    <AttendantDashboard
                      setAttendantNavbarBackLink={setAttendantNavbarBackLink}
                    />
                  </Route>
                  <Route exact path="/editor">
                    <NavbarAttendant
                      attendantNavbarBackLink={attendantNavbarBackLink}
                    />
                    <AttendantTileEditor />
                  </Route>
                  <Route exact path="/client">
                    <NavbarClient />
                    <ClientDashboard />
                  </Route>
                  <Route path="/clientlogin">
                    <ClientLogin />
                  </Route>
                  <Route
                    exact
                    path="/loaderio-faafa801558db05beec16c6856f2516e"
                  />
                  <Route path="*" render={(props) => <div>Not found!</div>} />
                </Switch>
              </Router>
            </ClientProvider>
          </AttendantProvider>
        </ExhibitorContext.Provider>
      </UserProvider>
    </div>
  );
};

export default styled(App)`
  height: 100%;
  width: 100%;
`;
